<template>
  <div
    :class="[
      $style.base,
      $style[color],
      {
        [$style.fullHeight]: fullHeight,
      },
    ]"
    v-test="'_base-icon-tile'"
  >
    <BaseIcon
      :name="name"
      :color="color"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import BaseIcon from '@/components/base-icon/index.vue';
import type { IconName } from '@/components/base-icon/types';

type Props = {
  name: IconName;
  color?: 'accent' | 'primary' | 'success' | 'warning' | 'error';
  fullHeight?: boolean;
};

withDefaults(defineProps<Props>(), {
  color: 'accent',
  fullHeight: false,
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: $radius;

  &.fullHeight {
    align-self: stretch;
    height: auto;
    min-height: 40px;
  }
}

// There is no accent tint token; the accent tile has always used the error tint.
.accent,
.error {
  background-color: var(--error-softer);
}

.primary {
  background-color: var(--action-primary-softer);
}

.success {
  background-color: var(--success-softer);
}

.warning {
  background-color: var(--warning-softer);
}
</style>
